import { fetchEntities } from 'actions/entities'
import SchemaForm from 'components/forms/SchemaForm'
import { healthFundSchema } from 'forms/superuser/healthFundSchema'
import React from 'react'
import { connect } from 'react-redux'

class HealthFundForm extends React.Component {
  componentDidMount() {
    this.props.fetchEntities()
  }

  render () {
    return (
      <SchemaForm entityName='healthFund' {...this.props}/>
      )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    uiSchema: healthFundSchema(state,ownProps),
    submitButton: true
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('countries', { superuser: false}))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HealthFundForm);
